"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Packages */

/* Icon Itself */
var IconPaymentPaypal = function IconPaymentPaypal(props) {
  /**
   * Inherit props
   */
  var size = props.size,
      width = props.width,
      height = props.height;
  /**
   * Render
   */

  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: width || size,
    height: height || size,
    viewBox: "0 0 30 30"
  }, _react.default.createElement("defs", null, _react.default.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "4",
    width: "30",
    height: "22.5",
    rx: "2"
  })), _react.default.createElement("g", {
    id: "Pagamento-/-PayPal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, _react.default.createElement("use", {
    xlinkHref: "#path-1"
  })), _react.default.createElement("use", {
    id: "Fundo",
    fill: "#FFC61E",
    xlinkHref: "#path-1"
  }), _react.default.createElement("g", {
    id: "Logo-PayPal",
    mask: "url(#mask-2)"
  }, _react.default.createElement("g", {
    transform: "translate(9.000000, 7.000000)",
    id: "Path"
  }, _react.default.createElement("path", {
    d: "M3.65643871,15.3022635 L3.91962581,13.5586222 L3.33336774,13.5444505 L0.533922581,13.5444505 L2.47939355,0.678141061 C2.49136448,0.596887959 2.55859173,0.537040578 2.63740645,0.53747169 L7.35766452,0.53747169 C8.92470968,0.53747169 10.0061419,0.877594314 10.5707613,1.54891197 C10.8354581,1.86383816 11.0040387,2.19293603 11.0855613,2.55510115 C11.1711097,2.93511208 11.1726194,3.38913067 11.0890839,3.94287589 L11.0830452,3.98329142 L11.0830452,4.33810826 L11.3477419,4.4945216 C11.5498158,4.6013026 11.7314519,4.74574783 11.8836774,4.92072171 C12.110129,5.1899836 12.2565677,5.53220339 12.3184645,5.9379333 C12.3823742,6.3552105 12.3612387,6.85174412 12.2565677,7.41388737 C12.1357935,8.06053581 11.9405419,8.62372881 11.6768516,9.0845708 C11.4441941,9.4974109 11.1313769,9.85497375 10.7584645,10.1343248 C10.4082194,10.393614 9.99205161,10.5904429 9.52153548,10.7164133 C9.0656129,10.8402843 8.54578065,10.9027447 7.97562581,10.9027447 L7.60827097,10.9027447 C7.3455871,10.9027447 7.09045161,11.0014215 6.89016774,11.1783051 C6.69016783,11.357076 6.55749247,11.6040835 6.51576774,11.8753417 L6.48809032,12.0322799 L6.02310968,15.1054347 L6.00197419,15.2182832 C5.99643871,15.2539748 5.98687742,15.2718207 5.9727871,15.2838928 C5.95913757,15.2955358 5.94210854,15.3020114 5.92447742,15.3022635 L3.65643871,15.3022635 Z",
    fill: "#253B80"
  }), _react.default.createElement("path", {
    d: "M11.5983484,4.02423182 C11.5842581,4.1181848 11.5681548,4.21423729 11.5500387,4.31291416 C10.9275484,7.64640787 8.79789677,8.79798797 6.07796129,8.79798797 L4.69308387,8.79798797 C4.36045161,8.79798797 4.08015484,9.04992892 4.02832258,9.39214872 L3.31927742,14.0824494 L3.11849032,15.4119628 C3.10230332,15.5186896 3.13171569,15.6274589 3.19898398,15.7096348 C3.26625226,15.7918108 3.36463555,15.8392127 3.46823226,15.8392127 L5.92447742,15.8392127 C6.21534194,15.8392127 6.46242581,15.6187644 6.50821935,15.3195845 L6.53237419,15.189415 L6.99483871,12.1283324 L7.02452903,11.9603718 C7.06981935,11.6601422 7.31740645,11.4396938 7.60827097,11.4396938 L7.97562581,11.4396938 C10.3553806,11.4396938 12.2183226,10.43193 12.7628129,7.5157135 C12.990271,6.29747403 12.8725161,5.28026244 12.2706581,4.56485511 C12.0799004,4.34354759 11.8520761,4.16034761 11.5983484,4.02423182 L11.5983484,4.02423182 Z",
    fill: "#179BD7"
  }), _react.default.createElement("path", {
    d: "M10.9471742,3.7533953 C10.7484133,3.69342348 10.5462166,3.6466161 10.3417935,3.61325314 C9.93786423,3.5485053 9.52962978,3.5174392 9.12096774,3.52034992 L5.42125161,3.52034992 C5.13032561,3.52016288 4.8826943,3.74118491 4.8380129,4.04102788 L4.05096774,9.24045927 L4.02832258,9.39214872 C4.07898592,9.05013605 4.36128845,8.79781528 4.69308387,8.79798797 L6.07796129,8.79798797 C8.79789677,8.79798797 10.9275484,7.645883 11.5500387,4.31291416 C11.5686581,4.21423729 11.5842581,4.1181848 11.5983484,4.02423182 C11.4340881,3.93438788 11.2628949,3.85906666 11.0865677,3.7990596 C11.0403405,3.78306126 10.99387,3.76783787 10.9471742,3.7533953 L10.9471742,3.7533953 Z",
    fill: "#222D65"
  }), _react.default.createElement("path", {
    d: "M4.8380129,4.04102788 C4.88232115,3.74104677 5.13025311,3.51993221 5.42125161,3.52087479 L9.12096774,3.52087479 C9.55927742,3.52087479 9.9684,3.55079278 10.3417935,3.61377802 C10.594467,3.65519724 10.8436512,3.71714631 11.087071,3.7990596 C11.2707484,3.86256971 11.4413419,3.93762712 11.5988516,4.02423182 C11.7840387,2.79234554 11.5973419,1.95359213 10.9587484,1.19409513 C10.2547355,0.357966102 8.98409032,-1.33226763e-14 7.35816774,-1.33226763e-14 L2.63790968,-1.33226763e-14 C2.30578065,-1.33226763e-14 2.02246452,0.251940951 1.97113548,0.594685621 L0.00503225806,13.5932641 C-0.0135007605,13.7153962 0.020123745,13.8398721 0.0970608222,13.9339481 C0.173997899,14.0280242 0.286545093,14.0822822 0.405096774,14.0824494 L3.31927742,14.0824494 L4.05096774,9.24045927 L4.8380129,4.04102788 Z",
    fill: "#253B80"
  })))));
};
/* Exporting */


var _default = IconPaymentPaypal;
exports.default = _default;